<template>
    <div class="platformContainer" v-if="contData">
        <div class="content" :style="{'min-height': contData.title ? '400px':'400px'}">
            <div class="platformItemBox">
                <div class="platformTitle">
                    <div :class="{title:true, act: index == platState}" @click="checkHandle('platState', index)" v-for="(item, index) in platformData" :key="index">
                        <span class="pfIcon" v-show="index != platState"><img v-if="item.icon && item.icon.length > 2"  :src="item.icon[1].url" alt="" width="20px"></span>
                        <span class="pfIcon" v-show="index == platState"><img v-if="item.icon && item.icon.length > 2"  :src="item.icon[2].url" alt="" width="20px"></span>
                        {{item.title}}
                    </div>
                </div>
                               
                <div class="content" :style="{'min-height': contData.title ? '400px':'400px'}">
                    <div class="info" :key="keyInt" v-if="contData.title">
                        <div class="title">{{contData.desc}}</div>
                        <div class="img"><img :src="contData.image[0].url" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        platformData:null
    },
    data(){
        return {
            platState: 0,
            labState: 0,
            labelData:null,
            contData:null,
            keyInt: 0,
        }
    },
    watch:{
        platformData:{
            handler(value){
                if (value){
                    this.initData(value)
                }
            }
        }
    },
    mounted(){
        console.log(this.platformData)
        if(this.platformData){
            this.initData()
        }
    },
    methods:{
        checkHandle(key, index){
            if(this[key] !== index){
                this[key] = index
                this.keyInt++
                this.initData()
            }
        },
        initData(){
            this.contData = this.platformData[this.platState]
        }
    }
}
</script>
<style scoped lang="scss">
  .platformContainer{
      max-width: 1090px;
      margin: 0 auto;
      
        .content{
            position: relative;
            // min-height: 575px;
            .platformItemBox{
                text-align: left;
                .platformTitle{
                    position: absolute;
                    left: 0px;
                    top:0;
                    display: inline-block;
                    // padding-right: 10px;
                    margin-bottom: 40px;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;
                    cursor: pointer;
                    min-height: 450px;
                    border-right: solid 1px #E0E2E3;
                    z-index: 1;
                    background: transparent;
                    .pfIcon{
                        img{
                            position: relative;
                            top: 4px;
                        }
                    }
                    .title{
                        position: relative;
                        right: -1px;
                        padding: 20px 35px 20px 0;
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                    .act{
                        color: #1386FF;
                        border-right: solid 2px #cccccc;
                        border-color:#1386FF;
                    }
                }
            }
            .labelList{
                display: flex;
                justify-content: center;
                margin-bottom: 60px;
                border-bottom: solid 1px #ededed;
                .labCont{
                    flex: 1;
                    cursor: pointer;
                    max-width: 147px;
                    text-align: center;
                    
                    .name{
                        line-height: 50px;
                        font-size: 14px;
                    }
                }
                .act{
                    position: relative;
                    &::before{
                        content: '';
                        display: inline-block;
                        animation:linelang 500ms forwards;
                        height: 1px;
                        width: 129px;
                        position: absolute;
                        bottom:0px;
                        left: 50%;
                        background: #1086ff;
                        transform: translateX(-50%);
                    }
                }
            }
            .content{
                // display: flex;
                margin-left: 113px;
                padding-top: 5px;
                .image{
                    flex: 1;
                    position: relative;
                    opacity:0;
                    animation: easeShow 750ms ease-in-out forwards;
                }
                .info{
                    // flex: 1;
                    // display: flex;
                    // flex-direction: column;
                    text-align: left;
                    // justify-content: center;
                    color: #19232B;
                    padding-left: 100px;
                    .title{
                        // opacity: 0;
                        // font-size: 60px;
                        // line-height: 120px;
                        // position: relative;
                        // top: 10px;
                        // font-weight: bold !important;
                        // animation: fontFloat 550ms ease-in-out forwards;
                        font-size: 14px;
color: #19232B;
text-align: justify;
line-height: 26px;
margin-bottom: 30px;
                    }
                    .img{
                        // opacity: 0;
                        // font-size: 24px;
                        // line-height: 33px;
                        // position: relative;
                        // font-weight: 500;
                        // margin-top: 20px;
                        // margin-bottom: 20px;
                        // top: 10px;
                        // animation: fontFloat 550ms ease-in-out 200ms forwards;
                        img{
                            width: 880px;
                            height: 344px;
                        }
                    }
                    .desc{
                        opacity: 0;
                        font-size: 16px;
                        line-height: 32px;
                        position: relative;
                        top: 10px;
                        animation: fontFloat 550ms ease-in-out 300ms forwards;
                    }
                }
            }
        }
        @keyframes fontFloat {
            0%{
                top: 10px;
                opacity: 0;
            }
            100%{
                top:-70px;
                opacity: 1;
            }
        }
        @keyframes easeShow {
            0%{
                top: 30px;
                opacity: 0;
            }
            100%{
                top: 0px;
                opacity:1;
            }
        }
        @keyframes linelang {
            from {width:0px;}
            to {width:129px;}
        }  
      
}
    @media (max-width: 1400px) {
        .platformTitle{
            left: -50px !important;
        }
    } 
    @media (max-width: 1240px) {
        .platformTitle{
            left: 0px !important;
        }
    } 
</style>